export default __webpack_public_path__ + "static/media/amex-single.c2c023b7.svg";